<template>
  <div class="tpl">
    <van-nav-bar title="亿起购" left-text="返回" right-text left-arrow fixed @click-left="onClickLeft" />
    <div style="height:46px"></div>
    <vue-swpier :items="slide" autoplay="5000"></vue-swpier>
    <van-divider :style="{ borderColor: '#888888', padding: '0 140px', color:'#1baeae' }">选择分类</van-divider>
    <div class="cat">
      <van-tree-select
        height="500"
        :items="categorys"
        :active-id.sync="activeId"
        :main-active-index.sync="activeIndex"
        @click-item="t"
        @click-nav="clickNav"
      >
        <template #content>
          <div class="secondCat">
            <div class="item" v-for="item in smallCatList " :key="item.id" v-on:click="$router.push('/shop/list/'+item.id+'/all')">
              <van-image :src="GLOBAL.IMG + item.img"  round width="50px" height="50px" />
              <div>{{item.text}}</div>
            </div>
          </div>
        </template>
      </van-tree-select>
    </div>
    <div style="height:64px"></div>
    <TabBar active="0" />
  </div>
</template>
<script>
import vueSwpier from "@/components/vueSwiper.vue";
import Vue from "vue";
import { TreeSelect } from "vant";
import { Divider } from "vant";
import TabBar from "@/components/TabBar.vue";
Vue.use(Divider);
Vue.use(TreeSelect);
export default {
  name: "goodsList",
  components: {
    vueSwpier,
    TabBar,
  },
  data() {
    return {
      categorys: [],
      secondCats: [],
      activeId: 1,
      activeIndex: 5,
      slide: [],
      goodsList: [],
      loading: false,
      finished: false,
      cPage: 1,
      cid: this.$route.params.cat,
      keyword: this.$route.params.keyword,
      scid: 0,
      smallCatList: []
    };
  },
  methods: {
    clickNav(index) {
      this.smallCatList = this.categorys[index].children;
    },

    t(data) {
      this.scid = data.id;
      this.goodsList = [];
      this.loading = false;
      this.finished = false;
      this.cPage = 1;
      this.getGoodsList();
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    getSlide(id) {
      this.$http
        .get(this.GLOBAL.API + "s_slide/index/slide?id=" + id, {
          params: {},
          headers: { "XX-Device-Type": "mobile" }
        })
        .then(response => {
          let data = response.body;
          if (data.code == 1) {
            this.slide = data.data;
          }
        });
    },
    getBigCat() {
      this.$http
        .get(this.GLOBAL.API + "s_shop/category/listCats", {
          params: { pid: 0 },
          headers: { "XX-Device-Type": "mobile" }
        })
        .then(response => {
          let data = response.body;
          if (data.code == 1) {
            this.categorys = data.data;
            for (let i in this.categorys) {
              if (this.categorys[i].id == this.cid) {
                this.activeIndex = i;
                this.clickNav(this.activeIndex)
              }
            }
          }
        });
    },
    getSmallCat() {
      this.$http
        .get(this.GLOBAL.API + "s_shop/category/listCats", {
          params: { pid: 0 },
          headers: { "XX-Device-Type": "mobile" }
        })
        .then(response => {
          let data = response.body;
          if (data.code == 1) {
            this.categorys = data.data;
            for (let i in this.categorys) {
              if (this.categorys[i].id == this.cid) {
                this.activeIndex = i;
              }
            }
          }
        });
    },
    getGoodsList() {
      this.$http
        .get(this.GLOBAL.API + "s_shop/goods/goodsList", {
          params: {
            scid: this.scid,
            cid: this.cid,
            keyword: this.keyword,
            page: this.cPage
          },
          headers: { "XX-Device-Type": "mobile" }
        })
        .then(response => {
          let data = response.body;
          this.loading = false;
          if (this.cPage >= data.data.last_page) {
            this.finished = true;
          } else {
            this.cPage++;
          }
          if (data.code == 1) {
            this.goodsList = this.goodsList.concat(data.data.data); //= data.data.data;
          }
        });
    }
  },

  mounted() {
    if (JSON.parse(localStorage.getItem("user"))) {
      this.user = JSON.parse(localStorage.getItem("user"));
    }
    this.getBigCat();
    switch (this.cid) {
      case "213":
        this.getSlide(6);
        break;

      default:
        this.getSlide(5);
        break;
    }
  }
};
</script>
<style lang="scss" scoped>
.tpl {
  text-align: left;
  background-color: #f6f6f6;
}
.van-tree-select__nav{ width:100px }
.secondCat{
    padding: 20px 10px 20px 10px;
    display: flex;
    flex-wrap: wrap;
    .item{
        width:33%;
        text-align: center;
        padding-bottom:40px;
    }
}
.van-sidebar-item--select {
  color: #1baeae;
}
.van-sidebar-item--select::before {
  background-color: #1baeae;
}
.goodsList {
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;
  .item {
    margin-top: 5px;
    background-color: #ffffff;
    width: 49.5%;
    .title {
      line-height: 20px;
      height: 40px;
      overflow: hidden;
      padding: 0 5px 0 5px;
    }
    .price {
      color: red;
      text-align: left;
      padding: 0 5px 0 5px;
    }
  }
}
</style>